export default __webpack_public_path__ + "static/media/saint-gobain_crane.e9b6c7ae.jpg";